import { createNavigation } from '../components/navigation.js';
import { createFooter } from '../components/footer.js';

export function createContactPage(): string {
  return `
    ${createNavigation()}

        <!-- Contact Section -->
    <section style="padding: 120px 0; background: #ffffff;">
        <div class="container">
            <!-- Header Section -->
            <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; margin-bottom: 80px;">
                <div style="padding-top: 40px;">
                    <h1 style="font-size: 4rem; font-weight: 800; color: #0f172a; margin-bottom: 2rem; line-height: 1.1; letter-spacing: -0.02em;">
                        Contact the<br>
                        <span class="accent">Founders</span>
                    </h1>
                    <p style="font-size: 1.125rem; color: #64748b; line-height: 1.7; margin-bottom: 2rem;">
                        Have any questions or requests about <em>VibeChk</em>? We'd love to hear from you.
                    </p>
                    <div class="accent-border" style="padding-left: 20px;">
                        <p style="color: #1e293b; font-weight: 500; margin-bottom: 0.5rem;">Talk to the founders</p>
                        <p style="color: #64748b; font-size: 0.95rem;">Our founders will respond within 24 hours</p>
                    </div>
                </div>
                
                <!-- Contact Form -->
                <div style="background: #fafbfc; padding: 3rem; border-radius: 24px; position: relative; border: 1px solid #e2e8f0;">
                    <!-- Success Message (initially hidden) -->
                    <div id="success-message" style="display: none; text-align: center; padding: 2rem 0;">
                        <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #10b981, #059669); border-radius: 50%; margin: 0 auto 1.5rem; display: flex; align-items: center; justify-content: center; animation: successPulse 0.6s ease-out;">
                            <svg width="28" height="28" fill="white" viewBox="0 0 24 24">
                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                            </svg>
                        </div>
                        <h3 style="color: #059669; font-size: 1.5rem; margin-bottom: 1rem; font-weight: 600;">Message sent!</h3>
                        <p style="color: #64748b; font-size: 1rem; margin-bottom: 1rem;">Our team will get back to you under 24 hours.</p>
                        <div id="countdown" style="color: #3b82f6; font-weight: 500; font-size: 0.95rem;"></div>
                    </div>

                    <!-- Contact Form -->
                    <form id="contact-form" action="https://formspree.io/f/mjkrolzk" method="POST" style="display: block;">
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem; margin-bottom: 1.5rem;">
                            <div>
                                <label for="name" style="display: block; font-weight: 500; color: #374151; margin-bottom: 0.5rem; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.05em;">Name</label>
                                <input 
                                    type="text" 
                                    id="name" 
                                    name="name" 
                                    required 
                                    style="width: 100%; padding: 0.875rem; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; transition: all 0.2s ease; background: white; box-sizing: border-box;"
                                    onfocus="this.style.borderColor='#3b82f6'; this.style.boxShadow='0 0 0 3px rgba(59,130,246,0.1)'"
                                    onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'"
                                    placeholder="Your name"
                                >
                            </div>
                            
                            <div>
                                <label for="email" style="display: block; font-weight: 500; color: #374151; margin-bottom: 0.5rem; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.05em;">Email</label>
                                <input 
                                    type="email" 
                                    id="email" 
                                    name="email" 
                                    required 
                                    style="width: 100%; padding: 0.875rem; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; transition: all 0.2s ease; background: white; box-sizing: border-box;"
                                    onfocus="this.style.borderColor='#3b82f6'; this.style.boxShadow='0 0 0 3px rgba(59,130,246,0.1)'"
                                    onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'"
                                    placeholder="your@email.com"
                                >
                            </div>
                        </div>

                        <div style="margin-bottom: 1.5rem;">
                            <label for="topic" style="display: block; font-weight: 500; color: #374151; margin-bottom: 0.5rem; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.05em;">Topic</label>
                            <select 
                                id="topic" 
                                name="topic" 
                                required 
                                style="width: 100%; padding: 0.875rem; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; transition: all 0.2s ease; background: white; box-sizing: border-box; appearance: none; background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"%23666\"><path d=\"M7 10l5 5 5-5z\"/></svg>'); background-repeat: no-repeat; background-position: right 0.75rem center; background-size: 1rem;"
                                onfocus="this.style.borderColor='#3b82f6'; this.style.boxShadow='0 0 0 3px rgba(59,130,246,0.1)'"
                                onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'"
                            >
                                <option value="">Select topic</option>
                                <option value="General Inquiry">General Inquiry</option>
                                <option value="Partnership">Partnership</option>
                                <option value="Technical Support">Support</option>
                                <option value="Feature Request">Feature Request</option>
                                <option value="Bug Report">Bug Report</option>
                                <option value="Press & Media">Press & Media</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>

                        <div style="margin-bottom: 2rem;">
                            <label for="message" style="display: block; font-weight: 500; color: #374151; margin-bottom: 0.5rem; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.05em;">Message</label>
                            <textarea 
                                id="message" 
                                name="message" 
                                required 
                                rows="4" 
                                style="width: 100%; padding: 0.875rem; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; transition: all 0.2s ease; background: white; resize: vertical; min-height: 100px; font-family: inherit; box-sizing: border-box;"
                                onfocus="this.style.borderColor='#3b82f6'; this.style.boxShadow='0 0 0 3px rgba(59,130,246,0.1)'"
                                onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'"
                                placeholder="Tell us about your inquiry..."
                            ></textarea>
                        </div>

                        <button 
                            type="submit" 
                            id="submit-btn"
                            style="width: 100%; background: #000; color: white; padding: 1rem 2rem; border: none; border-radius: 8px; font-size: 1rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; position: relative; overflow: hidden;"
                        >
                            <span id="btn-text">Send Message</span>
                            <span id="btn-loading" style="display: none; align-items: center; justify-content: center;">
                                <svg width="16" height="16" style="animation: spin 1s linear infinite; margin-right: 8px;" fill="white" viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" opacity="0.25"/>
                                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                </svg>
                                Sending...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section>

    <style>
        @keyframes successPulse {
            0% { transform: scale(0.8); opacity: 0; }
            50% { transform: scale(1.05); opacity: 1; }
            100% { transform: scale(1); opacity: 1; }
        }
        
        @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }
        
        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(20px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        #success-message {
            animation: fadeInUp 0.4s ease-out;
        }

        .accent-border {
            border-left: 3px solid hsl(0, 70%, 50%);
            animation: border-spectrum 10s infinite linear;
        }

        @keyframes border-spectrum {
            0% { border-left-color: hsl(0, 70%, 50%); }
            16.67% { border-left-color: hsl(60, 70%, 50%); }
            33.33% { border-left-color: hsl(120, 70%, 50%); }
            50% { border-left-color: hsl(180, 70%, 50%); }
            66.67% { border-left-color: hsl(240, 70%, 50%); }
            83.33% { border-left-color: hsl(300, 70%, 50%); }
            100% { border-left-color: hsl(360, 70%, 50%); }
        }

        #submit-btn {
            background: #000 !important;
            transition: background 0.2s ease !important;
        }

        #submit-btn:hover {
            background: #1f2937 !important;
        }

        #submit-btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
            transition: left 0.5s ease;
            pointer-events: none;
        }

        #submit-btn:hover::before {
            left: 100%;
        }
        
        @media (max-width: 768px) {
            .container > div {
                grid-template-columns: 1fr !important;
                gap: 40px !important;
            }
            
            .container h1 {
                font-size: 2.5rem !important;
            }
            
            .container form > div:first-child {
                grid-template-columns: 1fr !important;
            }
        }
    </style>

    <script>
        document.addEventListener('DOMContentLoaded', function() {
            const form = document.getElementById('contact-form');
            if (!form) return;
            
            form.addEventListener('submit', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const submitBtn = document.getElementById('submit-btn');
                const btnText = document.getElementById('btn-text');
                const btnLoading = document.getElementById('btn-loading');
                const successMessage = document.getElementById('success-message');
                const countdown = document.getElementById('countdown');
                
                // Show loading state
                btnText.style.display = 'none';
                btnLoading.style.display = 'inline-flex';
                submitBtn.disabled = true;
                submitBtn.style.background = '#666 !important';
                submitBtn.style.cursor = 'not-allowed';
                
                // Create form data
                const formData = new FormData(form);
                
                // Submit to Formspree via fetch
                fetch(form.action, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function(response) {
                    if (response.ok) {
                        // Hide form and show success message
                        form.style.display = 'none';
                        successMessage.style.display = 'block';
                        
                        // Start countdown
                        let seconds = 3;
                        countdown.textContent = 'Form will reset in ' + seconds + ' seconds...';
                        
                        const countdownInterval = setInterval(function() {
                            seconds--;
                            if (seconds > 0) {
                                countdown.textContent = 'Form will reset in ' + seconds + ' seconds...';
                            } else {
                                clearInterval(countdownInterval);
                                // Reset form
                                form.reset();
                                form.style.display = 'block';
                                successMessage.style.display = 'none';
                                
                                // Reset button state
                                btnText.style.display = 'inline';
                                btnLoading.style.display = 'none';
                                submitBtn.disabled = false;
                                submitBtn.style.background = '#000';
                                submitBtn.style.cursor = 'pointer';
                            }
                        }, 1000);
                    } else {
                        throw new Error('Form submission failed');
                    }
                }).catch(function(error) {
                    console.error('Form submission error:', error);
                    // Reset button state on error
                    btnText.style.display = 'inline';
                    btnLoading.style.display = 'none';
                    submitBtn.disabled = false;
                    submitBtn.style.background = '#000';
                    submitBtn.style.cursor = 'pointer';
                    
                    alert('Sorry, there was an error sending your message. Please try again.');
                });
                
                // Ensure form doesn't submit normally
                return false;
            });
        });
    </script>

        ${createFooter()}
    `;
} 